import { map } from 'rxjs/operators'
import { DELETE, GET, POST, PUT } from '../../../../module/services/fetch'
import { CatalogBaseSegregationConfigurationItem } from '../../../../models/Catalog'
/* import { mockEntitlement } from "../CatalogStepTwo/module/constants";
 */
export const fetchOfficeRequest = () =>
  GET('entitlement/ou').pipe(map((response: any) => response))

export const fetchOfficeEntitlementRequest = (id: string | number) =>
  GET(`entitlements?ou=${id}`).pipe(map((response: any) => response))

export const fetchEntitlementRequest = (obj: {}) =>
  POST('entitlements', obj).pipe(map((response: any) => response))

export const fetchCreateRequest = (abilitationObj: FormData) =>
  POST(
    'admin/request/createRequests',
    abilitationObj,
    undefined,
    undefined,
    undefined,
    'multipart/form-data'
  ).pipe(map((response: any) => response))

export const fetchChainEntitlementRequest = (ids: string[]) => {
  let queryParam: string = ids.join(',')
  return GET(`entitlements/entitlementsbyids?ids=${queryParam}`).pipe(
    map((response: any) => response)
  )
}

export const fetchGetPaginationTableStepOne = (payload: any) => {
  const { body, sortBy } = payload
  return POST(
    `admin/ou${
      sortBy && sortBy.length > 0
        ? `?sortField=${
            sortBy[0].id === 'ouCode' ? 'code' : sortBy[0].id
          }&sortOrder=${sortBy[0].desc ? 'desc' : 'asc'}`
        : ''
    }`,
    body
  ).pipe(map((response: any) => response))
}

export const fetchGetPaginationTableStepTwo = (payload: any) => {
  const { body, sortBy } = payload
  return POST(
    `admin/users/find${
      sortBy && sortBy.length > 0
        ? `?sortField=${sortBy[0].id}&sortOrder=${
            sortBy[0].desc ? 'desc' : 'asc'
          }`
        : ''
    }`,
    body
  ).pipe(map((response: any) => response))
}

export const fetchAdminGlobalCatalog = (payload: any) => {
  const { body, sortBy } = payload
  return POST(
    // `admin/entitlements/find${
    `admin/entitlements/findEntFromGlobal${
      sortBy && sortBy.length > 0
        ? `?sortField=${sortBy[0].id}&sortOrder=${
            sortBy[0].desc ? 'desc' : 'asc'
          }`
        : ''
    }`,
    body
  ).pipe(map((response: any) => response))
}

export const fetchHideOu = (ouCode: string) =>
  POST(`admin/ou/${ouCode}/hide`).pipe(map((response: any) => response))

export const fetchShowOu = (ouCode: string) =>
  POST(`admin/ou/${ouCode}/show`).pipe(map((response: any) => response))

// TODO
export const fetchSegregationsService = () =>
  GET('admin/global-catalog-mgmt').pipe(map((response: any) => response))

export const addSegregationService = (
  config: CatalogBaseSegregationConfigurationItem
) =>
  POST('admin/global-catalog-mgmt/add', config).pipe(
    map((response: any) => response)
  )

export const updateSegregationService = (body: {
  id: number
  config: Partial<CatalogBaseSegregationConfigurationItem>
}) => {
  const { config, id } = body
  return PUT(`admin/global-catalog-mgmt/update/${id}`, config).pipe(
    map((response: any) => response)
  )
}

export const deleteSegregationService = (id: number) =>
  DELETE(`admin/global-catalog-mgmt/delete/${id}`).pipe(
    map((response: any) => response)
  )
